

// wait until DOM is ready
document.addEventListener("DOMContentLoaded", function(event){

    console.log("DOM loaded");
   
    //wait until images, links, fonts, stylesheets, and js is loaded
    window.addEventListener("load", function(e){

                            // Register GSAP plugins
                            gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
                            


        // video header bg
                            gsap.to(".header-video", {
                                scrollTrigger: {
                                  trigger: ".header-video",
                                  start: "30% top", // Starts when the center of the section reaches the top
                                  end: "bottom top", // Ends when the section is fully out of view
                                  scrub: true, // Smooth transition
                                },
                                scale: 0.95, // 
                              });
                              
                             // gsap.to(".video, .header-video-foreground", {
                             //   scrollTrigger: {
                             //     trigger: ".header-video",
                             //     start: "center top",
                             //     end: "bottom top",
                             //     scrub: true,
                             //   },
                             //   borderRadius: "30px", // Increase border-radius smoothly
                             // });



            
      console.log("window loaded");
     }, false);
   
   });